module.exports = __webpack_public_path__ + "static/img/11.9c86ed7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tiankeng/11.jpg
// module id = jO87
// module chunks = 1